<template>
  <NotificationCard
    :icon="notificationMapping[type].icon"
    :title="notificationMapping[type].title"
    :date="new Date(created_at)"
    :read="!!read_at"
  >
    {{ notificationMapping[type].message }}
  </NotificationCard>
</template>

<script setup>
import { computed } from "vue";
import { NotificationCard } from "@/SharedComponents/NotificationCard";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const props = defineProps({
  type: { type: String, required: true },
  data: { type: Object, required: true },
  created_at: { type: String, required: true },
  read_at: { type: String, required: false },
});

const notificationMapping = computed(() => ({
  "comment.tagged": {
    icon: "mention",
    title: t("notifications.tagged_in_comment.in_app.title"),
    message: t("notifications.tagged_in_comment.in_app.message", {
      name: props.data.tagged_by,
      building: props.data.tenant,
    }),
  },
  "problem.reported": {
    icon: "message-plus",
    title: t("notifications.problem_reported.in_app.title"),
    message: t("notifications.problem_reported.in_app.message", {
      space: props.data.space,
      building: props.data.tenant,
    }),
  },
  "problem.upvoted": {
    icon: "arrow-up-circle",
    title: t("notifications.problem_upvoted.in_app.title"),
    message: t("notifications.problem_upvoted.in_app.message", {
      space: props.data.space,
      building: props.data.tenant,
    }),
  },
  "task.assigned": {
    icon: "user-single-checked",
    title: t("notifications.task_assigned.in_app.title"),
    message: t("notifications.task_assigned.in_app.message", {
      name: props.data.assigned_by,
      building: props.data.tenant,
    }),
  },
  "task.comment": {
    icon: "chat",
    title: t("notifications.new_task_comment.in_app.title"),
    message: t("notifications.new_task_comment.in_app.message", {
      name: props.data.commented_by,
      building: props.data.tenant,
    }),
  },
}));
</script>
